var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header'),_vm._t("default"),_c('TheFooter'),_c('SvgInclude')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }